import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../root/routes";
import { WorkflowSetupPageWrapper } from "./WorkflowSetupPageWrapper";

type ObjectionInstructionsPageProps = {
  embedded?: boolean;
};

export const ObjectionInstructionsPage = ({
  embedded = false,
}: ObjectionInstructionsPageProps = {}) => {
  const history = useHistory();
  const pageContent = <></>;

  if (embedded) {
    return pageContent;
  }

  return (
    <WorkflowSetupPageWrapper
      selectedTabKey="objection-request"
      nextOnClick={() =>
        history.push(Routes.organization.requestHandling.requestToRestrictProcessing)
      }
      nextDisabled={false}
      nextContent="Next"
    >
      {pageContent}
    </WorkflowSetupPageWrapper>
  );
};
